import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import Table from 'components/table/Table'
import { useDispatch } from 'react-redux'
import api from 'api/axios/foka'
import NoData from 'components/table/NoData'
import FixedTable from 'components/table/FixedTable'

const GroupListModal = ({ id, handleClose }) => {
  const dispatch = useDispatch()
  const [groups, setGroups] = useState([])
  const [isLoading, setLoading] = useState(false)
  useEffect(() => {
    ;(async () => {
      setLoading(true)
      const { data } = await api.creative.getAdGroupsByCreative(id)
      setLoading(false)
      setGroups(data.result)
    })()
    return () => {
      setGroups([])
    }
  }, [id, dispatch])

  return (
    <ConfirmModal
      title={
        <>
          등록 광고그룹 <span className="fc_emph">{groups.length}</span>
        </>
      }
      handleClose={handleClose}
      showCancelBtn={false}>
      <FixedTable
        caption="등록 광고그룹 리스트"
        loading={isLoading}
        emptyMessage={<NoData>등록된 광고그룹이 없습니다.</NoData>}>
        <Table.Head>
          <Table.Column title="광고그룹" className="inner_cell" width={409} />
          <Table.Column title="ON/OFF" className="inner_cell" />
        </Table.Head>
        <Table.Body>
          {groups.map(group => (
            <Table.Row key={group.name}>
              <td>
                <div className="inner_cell">
                  <span className="limit_line">{group.name}</span>
                </div>
              </td>
              <td>
                <div className="inner_cell">{group.status}</div>
              </td>
            </Table.Row>
          ))}
        </Table.Body>
      </FixedTable>
    </ConfirmModal>
  )
}

export default GroupListModal

GroupListModal.propTypes = {
  id: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
}
